import React from 'react';

const Close = ({ className, size }) => {
    return (
        <svg width="49" height="49" viewBox="0 0 49 49" fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path d="M18.1619 32.2596L30.662 18.6697" stroke="#FFC52F" strokeWidth="2" strokeLinecap="round" />
            <path d="M17.8019 18.9755L31.022 31.9531" stroke="#FFC52F" strokeWidth="2" strokeLinecap="round" />
            <rect x="0.5" y="0.5" width="48" height="48" rx="11.5" stroke="#FFC52F" />
        </svg>

    )
}

export default Close;